import React from 'react'
import { useTranslation } from 'react-i18next'
import { Student } from '../../swagger'
import { DynamicFieldStates } from '../Interfaces/DynamicFieldStates'
import DynamicFormField from './DynamicFormField'
import { useAuth } from '../Routes/AuthProvider'

interface ChildrenLastNameFieldProps {
  child: Student
  isEditMode: boolean
  updateForParent: (name: string, updatedValue: string) => void
  childNameStates: DynamicFieldStates
  isMobile?: boolean
}

const ChildrenLastNameField: React.FC<ChildrenLastNameFieldProps> = ({
  child,
  isEditMode,
  updateForParent,
  childNameStates,
  isMobile,
}) => {
  const { t } = useTranslation()
  const {
    permissionAbility,
    userDetails: { actingAs },
  } = useAuth()

  const canEditLastName = permissionAbility.can('editStudentLastName', 'Family')

  const isLastNameEditable =
    isEditMode && (canEditLastName || actingAs === 'parent')

  return (
    <DynamicFormField
      key={`${child.studentKey}-last-name`}
      id={`${child.studentKey}-last-name`}
      label={t('ChildrenSummaryCard.Children.Label.Name', 'Last Name')}
      name={`${child.studentKey}-lastName`}
      updateForParent={(name, updatedValue) =>
        updateForParent(name, updatedValue)
      }
      value={childNameStates[`${child.studentKey}-lastName`]?.state ?? ''}
      isValid={childNameStates[`${child.studentKey}-lastName`]?.isValid}
      required
      disabled={!isLastNameEditable}
      fullWidth={isMobile}
    />
  )
}

export default ChildrenLastNameField
